import { Button } from '@apollo/orbit';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { URLModal } from 'src/components/common/URLModal';
import Config from 'src/lib/config';
import { setOverlayVisibleLocation } from 'src/lib/routing';

import { AddNotificationWizard } from '../addNotificationWizard/AddNotificationWizard';

export function AddNotificationButton() {
  const location = useLocation();
  return (
    <>
      <Button
        variant="secondary"
        as={Link}
        to={setOverlayVisibleLocation({
          location,
          overlayName: Config.modals.addNotificationWizard,
        })}
      >
        Add notification
      </Button>
      <URLModal name={Config.modals.addNotificationWizard}>
        {({ isOpen, closeModal }) => (
          <AddNotificationWizard isOpen={isOpen} onClose={closeModal} />
        )}
      </URLModal>
    </>
  );
}
